import { trackById } from 'src/app/shared/utils/track-by.util';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { FormFieldType } from '../form/formFieldType.enum';
import { FormField } from '../form/formField.model';
import { DateFormatService } from 'src/app/services/dateFormat.service';
import { MatDialog } from '@angular/material/dialog';
import { ISearchFieldData } from '../grid/baseGrid.component';
import { TemplateFieldState } from 'src/app/models/templateFieldState.model';

@Component({
  standalone: false,
  selector: 'app-dynamic-form-field',
  templateUrl: './dynamic-form-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dynamic-form-field.component.scss'
})
export class DynamicFormFieldComponent implements OnChanges {
  @Input() field!: FormField;
  @Input() entity: any;
  @Input() templateState: TemplateFieldState | null | undefined = null;
  @Output() valueChanged = new EventEmitter<void>();
  FormFieldType = FormFieldType;
  isMultiple = false;

  constructor(private searchMatDialog: MatDialog, private dateFormatService: DateFormatService) { }

  onTimeChange(event: string, field: FormField, fieldItem: FormField = undefined, index = -1) {
    this.dateFormatService.applyTimeChange(this.entity, field, event, fieldItem, index);
    this.valueChanged.emit();
  }

  onKeyPressValidateInput(event: KeyboardEvent, displayFormat: RegExp): void {
    if (!displayFormat.test(event.key)) {
      event.preventDefault();
    }
  }

  clearSelect(field: any) {
    this.entity[field.property] = null;
    field?.onChange?.({ value: null }, field);
    this.valueChanged.emit();
  }

  public trackById = trackById;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['field']) {
      this.isMultiple = this.field?.type === FormFieldType.MultipleSelection ||
        (this.field?.type === FormFieldType.HierarchicalSelection && this.field?.multiple);
    }
  }

  openSearchDialog(field: FormField) {
    const data: ISearchFieldData = {
      ...field?.additonalSearchData,
      selected: this.entity[field.property],
      isMultiple: field.type === FormFieldType.MultipleSelection,
    }

    const dialogRef = this.searchMatDialog.open(field.searchComponent, {
      width: '960px',
      data: data,
      panelClass: 'resizable-dialog',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      const { value, items } = result;
      if (!(typeof value === 'boolean')) {
        if (data.isMultiple) {
          (items || []).forEach(item => {
            const exists = field.options.some(opt => opt.id === item.id);
            if (!exists) field.options.push(item);
          });
        } else if (items) {
          const exists = field.options.some(opt => opt.id === items.id);
          if (!exists) field.options.push(items);
        }
        this.entity[field.property] = typeof value === 'object' ? [...value] : value;
        field.onChange({ value: value }, field);
        this.valueChanged.emit();
      }
    })
  }

  emitValueChanged(): void {
    this.valueChanged.emit();
  }
}
